import { selectionBoxTarget } from '@/Engine/SelectionBox';
import { Shelf, wardrobeModule } from '@/Interfaces/common';
import { $ } from '@/Engine/stateInstance';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { tempDoorDataTemplate, tempWindowDataTemplate } from '@/Constants/demo';
import { addDoor, addWindow } from '@/Engine/addDoorAndWindow';
import { Door } from '@/Engine/Door';
import { Window } from '@/Engine/Window';
import { useUIOnlyStore } from '@/Store/storeUI';

export function onCtrlKeyMoving(target: selectionBoxTarget) {
    // Делаем копию полки
    if ([ 'shelf', 'panel' ].includes(target.type)) {
        const shelf = target as Shelf;
        console.log(shelf);
        const newShelfTemplate = shelf.raw;
        newShelfTemplate.uuid = crypto.randomUUID();
        const newShelf = $.wardrobe.addShelf(newShelfTemplate);
        const [ newModuleTemplate, newModule ] =
            $.wardrobe.addModuleForShelf(newShelfTemplate, $.wardrobe.rackModules.map((item)=>item.raw), newShelf);
        $.wardrobe.addRailForRack(newModuleTemplate,  $.wardrobe.railGroup.map((item)=>item.raw), newModule);
        $.selectionBox.unselect();
        $.selectionBoxForBox.unselect();
        console.log(newShelf);
        newShelf?.select();
        useUIOnlyStore().setSelectedSceneObject(
            newShelf.uuid,
            newShelf?.humanName,
            `${(newShelf.width * 1000).toFixed()}x${(newShelf.height * 1000).toFixed()}x${(newShelf.depth * 1000).toFixed()}`,
            newShelf.rodAvailable,
            !!newShelf.items?.rod,
        );
        // newShelf.position = newShelf.position.clone();
        $.ctrlKey = false;
        return;
    }
    //  Делаем копию модуля
    else if ([ 'rackModule' ].includes(target.type)) {
        const rackModule = target as RackModule;
        $.selectionBox.unselect();
        $.selectionBoxForBox.unselect();

        let newRackTemplate: null | wardrobeModule = null;
        let newRackModule: null | RackModule = null;

        rackModule.shelves.forEach((shelf)=>{
            const newShelfTemplate = shelf.raw;
            newShelfTemplate.uuid = crypto.randomUUID();
            newShelfTemplate.rackModuleUUID = undefined;
            const newShelf = $.wardrobe.addShelf(newShelfTemplate);

            if (newShelf) {
                if (newRackTemplate && newRackModule) {
                    newShelfTemplate.rackModuleUUID = newRackModule.uuid;
                    $.wardrobe.addModuleForShelf(newShelfTemplate, [ newRackTemplate ], newShelf);
                }
                else {
                    [ newRackTemplate, newRackModule ] = $.wardrobe.addModuleForShelf(newShelfTemplate, [], newShelf);
                }
                newShelf.place = newShelfTemplate.place ?? 0;
            }

        });
        if (newRackTemplate && newRackModule) {
            $.wardrobe.addRailForRack(newRackTemplate,[],newRackModule);
            newRackModule.select();
        }
        $.ctrlKey = false;
        return;
    } else if ([ 'window' ].includes(target.type)) {
        // Копия окна
        const originalWindow = target as Window;
        $.tempWindowData = {
            ...tempWindowDataTemplate,
            width: originalWindow.width,
            height: originalWindow.height,
            side: $.selectionBox.side,
            position: target.position.toArray() };
        const window = addWindow($.tempWindowData);
        $.selectionBox.unselect();
        $.selectionBoxForBox.unselect();
        window.select();
        $.ctrlKey = false;
        return;
    } else if ([ 'door' ].includes(target.type)) {
        // Копия двери
        const originalDoor = target as Door;
        $.tempDoorData = {
            ...tempDoorDataTemplate,
            width: originalDoor.width,
            height: originalDoor.height,
            side: $.selectionBox.side,
            position: target.position.toArray() };
        const door = addDoor($.tempDoorData);
        $.selectionBox.unselect();
        $.selectionBoxForBox.unselect();
        door.select();
        $.ctrlKey = false;
        return;
    }
    // TODO for box
}
